export default __webpack_public_path__ + "static/media/disposal-empty-cion.e5164d28.svg";